import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Users, User, Prohibit, CurrencyDollar } from '@phosphor-icons/react';

export function PlatformStats({ stats, formatCurrency }) {
  if (!stats) return null;

  const items = [
    { label: 'Total Users', value: stats.total_users, icon: Users, color: '#22C55E' },
    { label: 'Active', value: stats.active_users, icon: User, color: '#22C55E' },
    { label: 'Banned', value: stats.banned_users, icon: Prohibit, color: '#EF4444' },
    { label: 'Total Volume', value: formatCurrency(stats.total_volume), icon: CurrencyDollar, color: '#F59E0B' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-8">
      {items.map(({ label, value, icon: Icon, color }) => (
        <Card key={label} className="bg-[#1A1A1A] border-[#222222] rounded-lg">
          <CardContent className="p-4 flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}15` }}>
              <Icon className="h-5 w-5" style={{ color }} weight="duotone" />
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-wider text-[#666666] font-semibold">{label}</p>
              <p className="text-lg font-bold text-white">{value}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
